import { render, staticRenderFns } from "./SwiftaTransactionDetail.vue?vue&type=template&id=f0796036&scoped=true"
import script from "./SwiftaTransactionDetail.vue?vue&type=script&lang=js"
export * from "./SwiftaTransactionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0796036",
  null
  
)

export default component.exports